import React, { useState, useEffect, useRef } from "react"

const Toast = ({ message, type = "info", duration = 3000, onClose }) => {
	const typeStyles = {
		info: "bg-blue-400 text-white",
		success: "bg-green-400 text-white",
		error: "bg-red-400 text-white",
		warning: "bg-yellow-400 text-black",
	}

	const [isVisible, setIsVisible] = useState(true)
	const onCloseRef = useRef(onClose)
	const animationTimerRef = useRef(null)

	// Update ref when onClose changes
	useEffect(() => {
		onCloseRef.current = onClose
	}, [onClose])

	useEffect(() => {
		const timer = setTimeout(() => {
			setIsVisible(false) // Trigger fade-out
			animationTimerRef.current = setTimeout(() => {
				onCloseRef.current && onCloseRef.current() // Remove toast after animation ends
			}, 300)
		}, duration)

		return () => {
			clearTimeout(timer)
			if (animationTimerRef.current) {
				clearTimeout(animationTimerRef.current)
			}
		}
	}, [duration])

	if (!isVisible) return null

	return (
		<div
			className={`fixed top-5 right-5 z-50 flex items-center space-x-4 p-4 rounded-lg shadow-lg w-80 justify-between animate-toast-in ${typeStyles[type]}`}
		>
            <span className="text-sm font-medium">{message}</span>
			<button
				className="text-white hover:text-gray-100 focus:outline-none"
				onClick={() => {
					setIsVisible(false);
					// Clear any pending animation timer
					if (animationTimerRef.current) {
						clearTimeout(animationTimerRef.current);
					}
					onCloseRef.current && onCloseRef.current();
				}}
			>
				<svg
					className="w-6 h-6"
					fill="none"
					stroke="currentColor"
					viewBox="0 0 24 24"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth={2}
						d="M6 18L18 6M6 6l12 12"
					/>
				</svg>
			</button>
		</div>
	)
}

export default Toast

